'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MessageIfExists = require('./components/MessageIfExists.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessageIfExists).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/localization-message-if-exists/lib/index.js
// module id = 1424
// module chunks = 1